import React, {
  useEffect,
  Fragment,
  useState,
  useRef,
  useCallback,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Sidebar from "../components/Sidebar.js";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import axios from "axios";
import PublishIcon from "@mui/icons-material/Publish";
import { API_URL, MAIN_TITLE, loadUser } from "../actions/auth.js";
import InputBase from "@mui/material/InputBase";
import CircularProgress from "@mui/material/CircularProgress";
import { alertMessage } from "../actions/auth.js";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import { themeStyle } from "../components/Components.js";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const ScrollLazyList = ({
  items,
  itemsPerPage = 50,
  user_id,
  full_name,
  selectedContact,
  handleContactClick,
}) => {
  const [visibleItems, setVisibleItems] = useState([]);
  const [loadedCount, setLoadedCount] = useState(0);
  const scrollRef = useRef(null);

  useEffect(() => {
    const initialCount = Math.min(itemsPerPage, items.length);
    setVisibleItems(items.slice(0, initialCount));
    setLoadedCount(initialCount);
  }, [items, itemsPerPage]);

  const handleScroll = useCallback(
    (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
      // Load more when 50px from bottom
      if (scrollHeight - scrollTop - clientHeight < 50) {
        if (loadedCount < items.length) {
          const nextCount = Math.min(loadedCount + itemsPerPage, items.length);
          const newItems = items.slice(loadedCount, nextCount);

          setVisibleItems((prev) => [...prev, ...newItems]);
          setLoadedCount(nextCount);
        }
      }
    },
    [loadedCount, items, itemsPerPage],
  );

  const hasMore = loadedCount < items.length;
  return (
    <div>
      <Box
        ref={scrollRef}
        onScroll={handleScroll}
        sx={{
          marginTop: "70px",
          width: "24vw",
          height: "100vh",
          overflowX: "hidden",
          overflowY: "scroll",
          border: "1px solid #ddd",
          borderRadius: 1,
        }}
      >
        {visibleItems.map((chat, index) => (
          <ListItem
            key={index}
            button
            style={{
              width: "110%",
              backgroundColor:
                chat[Object.keys(chat)[0]][user_id] &&
                chat[Object.keys(chat)[0]][user_id] != 0
                  ? "#ECFFDC"
                  : Object.keys(chat)[0] == selectedContact
                    ? themeStyle.primaryColorLight
                    : "",
            }}
            onClick={() => {
              handleContactClick(
                Object.keys(chat)[0],
                index,
                chat[Object.keys(chat)[0]]["user2"] == full_name
                  ? chat[Object.keys(chat)[0]]["user1"]
                  : chat[Object.keys(chat)[0]]["user2"],
                items,
              );
            }}
          >
            <ListItemIcon>
              <Avatar
                alt={
                  chat[Object.keys(chat)[0]]["user2"] == full_name
                    ? chat[Object.keys(chat)[0]]["user1"]
                    : chat[Object.keys(chat)[0]]["user2"]
                }
                src={API_URL + "/media/" + chat["image"]}
              />
            </ListItemIcon>
            <div>
              <ListItemText>
                {chat[Object.keys(chat)[0]]["user2"] == full_name
                  ? chat[Object.keys(chat)[0]]["user1"]
                  : chat[Object.keys(chat)[0]]["user2"]}
              </ListItemText>
              <div
                style={{ marginTop: "-10px", fontSize: "16px", color: "#888" }}
              >
                {chat["subtitle"]}
              </div>
            </div>
            {chat[Object.keys(chat)[0]][user_id] &&
            chat[Object.keys(chat)[0]][user_id] != 0 ? (
              <div
                style={{
                  marginTop: "-13px",
                  marginLeft: "10px",
                  height: "20px",
                  width: "20px",
                  backgroundColor: themeStyle.primaryColor,
                  borderRadius: "20px",
                }}
              >
                <div
                  style={{
                    marginLeft: "6px",
                    marginTop: "0px",
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  {chat[Object.keys(chat)[0]][user_id]}
                </div>
              </div>
            ) : (
              ""
            )}
          </ListItem>
        ))}
        <Fragment>
          {hasMore && (
            <div sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
              <CircularProgress size={24} />
            </div>
          )}
        </Fragment>
      </Box>
    </div>
  );
};

function Messenger() {
  const [open2, setOpen2] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [loading, setLoading] = React.useState(true);

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);

  const [selectedFile, setSelectedFile] = useState("");
  const [selectedContact, setSelectedContact] = useState("");
  const [isSending, setIsSending] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [filterClass, setFilterClass] = useState(false);

  const [searchText, setSearchText] = useState("");

  const [selectedContactIndex, setSelectedContactIndex] = useState("");
  const [textMessage, setTextMessage] = useState("");
  const [chatId, setChatId] = useState("");
  const [messageIndex, setMessageIndex] = useState("");
  const [messageKey, setMessageKey] = useState("");
  const [selectedContactName, setSelectedContactName] = useState("");
  const [currentContacts, setCurrentContacts] = useState(
    state.auth.messages ?? [],
  );
  const [allContacts, setAllContacts] = useState(state.auth.messages ?? []);
  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [studentList, setStudentList] = useState([]);
  const [classList, setClassList] = useState({});
  const [audio, setAudio] = useState(
    new Audio(require("../sounds/notification.mp3")),
  );
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();

  function getData() {
    console.log("WHAHTA");
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;

    body = JSON.stringify(body);
    axios.post(API_URL + "/get_class_list", body, config).then((res) => {
      var classListTemp = res.data;
      setClassList(classListTemp);
      console.log(classList);
      setClass(Object.keys(classListTemp)[0]);
      setDivision(Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]);
      setIsLoading(false);
    });
  }

  const handleOpen = () => {
    setOpen(true);
  };

  function handleClassChange(e) {
    setClass(e.target.value);
  }

  function handleDivisionChange(e) {
    setDivision(e.target.value);
  }

  function getClassList() {
    var classes = Object.keys(classList).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    return classes;
  }

  function getDivisionList() {
    var classes = Object.keys(classList[classs]).map((division, index) => (
      <MenuItem value={division}>{division}</MenuItem>
    ));
    return classes;
  }

  function handleSearch(text) {
    setSearchText(text);
    if (text.length == 0) {
      setCurrentContacts(allContacts);

      handleContactClick(
        Object.keys(allContacts[0])[0],
        0,
        allContacts[0][Object.keys(allContacts[0])[0]]["user2"] ==
          state.auth.user.full_name
          ? allContacts[0][Object.keys(allContacts[0])[0]]["user1"]
          : allContacts[0][Object.keys(allContacts[0])[0]]["user2"],
        allContacts,
      );
    } else {
      var tempContacts = [];
      for (var i = 0; i < allContacts.length; i++) {
        if (
          allContacts[i][Object.keys(allContacts[i])[0]]["user2"] ==
          state.auth.user.full_name
        ) {
          if (
            allContacts[i][Object.keys(allContacts[i])[0]]["user1"]
              .toLowerCase()
              .includes(text.toLowerCase())
          ) {
            tempContacts.push(allContacts[i]);
          }
        }

        if (
          allContacts[i][Object.keys(allContacts[i])[0]]["user1"] ==
          state.auth.user.full_name
        ) {
          if (
            allContacts[i][Object.keys(allContacts[i])[0]]["user2"]
              .toLowerCase()
              .includes(text.toLowerCase())
          ) {
            tempContacts.push(allContacts[i]);
          }
        }
      }

      setCurrentContacts(tempContacts);

      handleContactClick(
        Object.keys(tempContacts[0])[0],
        0,
        tempContacts[0][Object.keys(tempContacts[0])[0]]["user2"] ==
          state.auth.user.full_name
          ? tempContacts[0][Object.keys(tempContacts[0])[0]]["user1"]
          : tempContacts[0][Object.keys(tempContacts[0])[0]]["user2"],
        tempContacts,
      );
    }
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      audio.load();
      getData();
      console.log("HAIN?");
      if (state.auth.messages) {
        setAllContacts(state.auth.messages);
        setCurrentContacts(state.auth.messages);
      } else {
        setAllContacts([]);
        setCurrentContacts([]);
      }
    }
  }, [state.auth.isLoading, state.auth.messages]);

  if (state.auth.refresh == "REFRESH_DATA") {
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  function getSize(fileSize) {
    if (fileSize < 1024) {
      return <p>Size: {(fileSize / 1024).toFixed(2)} B</p>;
    } else if (fileSize > 1024 && fileSize < 1024 * 1024) {
      return <p>Size: {(fileSize / (1024 * 1024)).toFixed(2)} KB</p>;
    } else if (fileSize > 1024 * 1024 && fileSize < 25 * 1024 * 1024) {
      return <p>Size: {(fileSize / (1024 * 1024)).toFixed(2)} MB</p>;
    } else if (fileSize > 25 * 1024 * 1024) {
      setOpen(false);
      createAlert(
        "ERROR",
        "File too big.",
        "File size should be less than 25 MB.",
      );
    }
  }

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>
          <h2>File Details:</h2>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File too big.",
                    "File size should be less than 25 MB.",
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : selectedFile.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File name to obig.",
                    "File size should be less than 50 characters.",
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUpload() {
    setIsSending(true);

    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);
    var time = new Date();
    state.auth.client.send(
      JSON.stringify({
        type: "text",
        sender: state.auth.user.user_id,
        receiver: selectedContact,
        message: textMessage,
        group_name: state.auth.user.user_id,
        time: time.toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
        date:
          time.getDate() +
          " " +
          monthNames[time.getMonth()] +
          ", " +
          time.getFullYear(),
      }),
    );
    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };
    var time = new Date();
    formData.append("sender", state.auth.user.user_id);
    formData.append("receiver", selectedContact);
    formData.append("message", selectedFile.name);
    formData.append(
      "time",
      time.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }),
    );
    formData.append("institution_id", state.auth.user.institution_id);
    formData.append("sent_by", "principal");
    formData.append(
      "date",
      time.getDate() +
        " " +
        monthNames[time.getMonth()] +
        ", " +
        time.getFullYear(),
    );

    formData.append("type", "attachment");
    formData.append("sender_name", state.auth.user.full_name);
    formData.append("receiver_name", selectedContactName);

    axios.post(API_URL + "/send_attachment", formData, config);

    setOpen(false);
    document.getElementById("contained-button-file").value = "";
  }

  function onFileChange(event) {
    setSelectedFile(event.target.files[0]);
    handleOpen();
  }

  function onFileClick(event) {
    document.getElementById("contained-button-file").value = "";
  }

  function handleContactClick(contact, index, name, currentConts) {
    setSelectedContact(contact);
    setSelectedContactIndex(index);
    setSelectedContactName(name);

    if (
      currentConts[index][contact][state.auth.user.user_id] &&
      currentConts[index][contact][state.auth.user.user_id] != 0
    ) {
      var body = {};
      const config = {
        headers: {
          Authorization: state.auth.token,

          "Content-Type": "application/json",
        },
      };
      body["sender"] = selectedContact;
      body["receiver"] = state.auth.user.user_id;
      body = JSON.stringify(body);

      axios.post(API_URL + "/mark_read", body, config);
    }

    var tempMessages = currentConts;
    tempMessages[index][contact][state.auth.user.user_id] = 0;
    setCurrentContacts(tempMessages);
  }

  function handleTextChange(e) {
    setTextMessage(e.target.value);
  }

  var chats;
  var messages;

  function sendMessage() {
    setIsSending(true);

    if (textMessage != "") {
      var time = new Date();

      var body = {};
      const config = {
        headers: {
          Authorization: state.auth.token,

          "Content-Type": "application/json",
        },
      };
      var time = new Date();
      body["sender"] = state.auth.user.user_id;
      body["receiver"] = selectedContact;
      body["message"] = textMessage;
      body["time"] = time.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
      body["institution_id"] = state.auth.user.institution_id;
      body["sent_by"] = "principal";
      body["sender_name"] = state.auth.user.full_name;
      body["receiver_name"] = selectedContactName;
      body["date"] =
        time.getDate() +
        " " +
        monthNames[time.getMonth()] +
        ", " +
        time.getFullYear();

      body["type"] = "text";
      body = JSON.stringify(body);

      axios.post(API_URL + "/send_message", body, config);
    }
  }

  function deleteMessage() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["chat_id"] = chatId;
    body["message_key"] = messageIndex;
    var tempChatMessages = JSON.stringify(currentContacts);

    var tempChats = JSON.parse(tempChatMessages);

    delete tempChats[selectedContactIndex][
      Object.keys(tempChats[selectedContactIndex])[0]
    ]["messages"][messageIndex];

    setCurrentContacts(tempChats);
    setTextMessage(makeid(5));
    setTextMessage("");

    body = JSON.stringify(body);

    axios
      .post(API_URL + "/delete_message", body, config)
      .then((_) => setOpen2(false));
  }

  function getMessage(key, message, align, index, chat_id) {
    if (message != null && Object.keys(message).length != 0) {
      if (message["type"] == "attachment") {
        return (
          <span>
            <span
              style={{
                borderBottomRightRadius: align ? 2 : 10,
                borderBottomLeftRadius: align ? 10 : 2,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                padding: 10,
                backgroundColor: align
                  ? themeStyle.secondaryColor
                  : themeStyle.primaryColor,
                alignSelf: "flex-start",
                display: "inline-block",
              }}
            >
              <a
                target="_blank"
                style={{ color: "white" }}
                href={message[key].split("#link")[1]}
                rel="noreferrer"
              >
                {message[key].split("#link")[0]}
              </a>
              <span
                style={{
                  margin: "15px 0px 0px 20px",
                  fontSize: "10px",
                  color: "white",
                }}
              >
                {message["time"]}
                {align ? (
                  <KeyboardArrowDownIcon
                    onClick={(event) => {
                      setChatId(chat_id);
                      setMessageIndex(index);
                      setMessageKey(key);
                      setAnchorEl(event.currentTarget);
                    }}
                    style={{
                      color: "white",
                    }}
                  />
                ) : (
                  ""
                )}
              </span>
            </span>
          </span>
        );
      } else {
        return (
          <span>
            <span
              style={{
                borderBottomRightRadius: align ? 2 : 10,
                borderBottomLeftRadius: align ? 10 : 2,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                padding: 10,
                backgroundColor: align
                  ? themeStyle.secondaryColor
                  : themeStyle.primaryColor,
                alignSelf: "flex-start",
                display: "inline-block",
                color: "white",
              }}
            >
              {message[key]}
              <span
                style={{
                  margin: "15px 0px 0px 20px",
                  fontSize: "10px",
                }}
              >
                {message["time"]}
                {align ? (
                  <KeyboardArrowDownIcon
                    onClick={(event) => {
                      setChatId(chat_id);
                      setMessageIndex(index);
                      setMessageKey(key);
                      setAnchorEl(event.currentTarget);
                    }}
                    style={{
                      marginTop: "-10px",
                      marginRight: "-5px",
                      color: "white",
                    }}
                  />
                ) : (
                  ""
                )}
              </span>
            </span>
          </span>
        );
      }
    } else {
      return (
        <span
          style={{
            borderRadius: "0px",
            margin: "0px 0px 0px 30px",
            display: "inline-block",
            backgroundColor: "white",
            color: "#2171b5",
          }}
        >
          <h2>
            Send your first message to{" "}
            {currentContacts[selectedContactIndex][selectedContact]["user2"]}
          </h2>
        </span>
      );
    }
  }

  function playAudio() {
    const audioPromise = audio.play();
    if (audioPromise !== undefined) {
      audioPromise
        .then((_) => {
          // autoplay started
        })
        .catch((err) => {
          // catch dom exception
          console.info(err);
        });
    }
  }

  if (state.auth.newMessage) {
    dispatch({ type: "NO_NEW_MESSAGE" });
    var message = state.auth.newMessage;

    setIsSending(false);
    var type = message["type"];
    if (type == "text" || type == "attachment") {
      const dataFromServer = message;
      if (dataFromServer["sender"] != state.auth.user.user_id) {
        playAudio();
      }
      var allMessages = state.auth.messages;
      for (var i = 0; i < allMessages.length; i++) {
        if (Object.keys(allMessages[i])[0] == dataFromServer["receiver"]) {
          var messages = allMessages[i][dataFromServer["receiver"]];
          var maxKey =
            Math.max.apply(
              null,
              Object.keys(
                allMessages[i][dataFromServer["receiver"]]["messages"],
              ),
            ) + 1;

          var a = {};
          a[state.auth.user.user_id] = dataFromServer["message"];
          a["time"] = dataFromServer["time"];
          a["date"] = dataFromServer["date"];
          a["type"] = dataFromServer["type"];
          messages["messages"][maxKey] = a;

          allMessages[i][dataFromServer["receiver"]] = messages;
          break;
        } else if (Object.keys(allMessages[i])[0] == dataFromServer["sender"]) {
          var messages = allMessages[i][dataFromServer["sender"]];
          var maxKey =
            Math.max.apply(
              null,
              Object.keys(allMessages[i][dataFromServer["sender"]]["messages"]),
            ) + 1;

          var a = {};
          a[dataFromServer["sender"]] = dataFromServer["message"];
          a["time"] = dataFromServer["time"];
          a["date"] = dataFromServer["date"];
          a["type"] = dataFromServer["type"];
          messages["messages"][maxKey] = a;

          allMessages[i][dataFromServer["sender"]] = messages;

          break;
        }
      }

      setCurrentContacts(allMessages);
      setTextMessage("a");
      setTextMessage("");
    }
  }

  const AlwaysScrollToBottom = () => {
    const elementRef = useRef();
    useEffect(() => elementRef.current.scrollIntoView());
    return <div ref={elementRef} />;
  };

  function getMessages() {
    if (state.auth.messages && selectedContact) {
      var newMessages;

      messages =
        currentContacts[selectedContactIndex][selectedContact]["messages"];
      try {
        newMessages = Object.keys(messages).map((key, index) => (
          <ListItemText
            style={{ margin: "10px" }}
            align={
              Object.keys(messages[key])[0] == state.auth.user.user_id
                ? "right"
                : "left"
            }
          >
            {getMessage(
              Object.keys(messages[key])[0],
              messages[key],
              Object.keys(messages[key])[0] == state.auth.user.user_id
                ? true
                : false,
              key,
              currentContacts[selectedContactIndex]["chat_id"],
            )}
            <AlwaysScrollToBottom />
          </ListItemText>
        ));
      } catch (e) {
        newMessages = "";
      }
    }
    return newMessages;
  }

  if (!isLoading && !state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (moment(state.auth.expiry).utc().isAfter(moment())) {
        if (state.auth.message != null) {
          const dataFromServer = state.auth.message;
          dispatch({ type: "TEXT_MESSAGE", payload: null });

          var allMessages = currentContacts;
          for (var i = 0; i < allMessages.length; i++) {
            if (Object.keys(allMessages[i])[0] == dataFromServer["receiver"]) {
              var messages = allMessages[i][dataFromServer["receiver"]];
              var maxKey =
                Math.max.apply(
                  null,
                  Object.keys(
                    allMessages[i][dataFromServer["receiver"]]["messages"],
                  ),
                ) + 1;

              var a = {};
              a[state.auth.user.user_id] = dataFromServer["message"];
              a["time"] = dataFromServer["time"];
              a["date"] = dataFromServer["date"];
              a["type"] = dataFromServer["type"];
              messages["messages"][maxKey] = a;

              allMessages[i][dataFromServer["receiver"]] = messages;
              break;
            } else if (
              Object.keys(allMessages[i])[0] == dataFromServer["sender"]
            ) {
              var messages = allMessages[i][dataFromServer["sender"]];
              var maxKey =
                Math.max.apply(
                  null,
                  Object.keys(
                    allMessages[i][dataFromServer["sender"]]["messages"],
                  ),
                ) + 1;

              var a = {};
              a[dataFromServer["sender"]] = dataFromServer["message"];
              a["time"] = dataFromServer["time"];
              a["date"] = dataFromServer["date"];
              a["type"] = dataFromServer["type"];
              messages["messages"][maxKey] = a;

              allMessages[i][dataFromServer["sender"]] = messages;
              break;
            }
          }
          setCurrentContacts(allMessages);
          setTextMessage("a");
          setTextMessage("");
          setIsSending(false);
        }

        if (!state.auth.isLoadingMessages && state.auth.messages != null) {
          if (loading) {
            setCurrentContacts(state.auth.messages);
            if (state.auth.messages.length != 0) {
              setSelectedContact(Object.keys(state.auth.messages[0])[0]);
              setSelectedContactIndex(0);
              setSelectedContactName(
                state.auth.messages[0][Object.keys(state.auth.messages[0])[0]][
                  "user2"
                ] == state.auth.user.full_name
                  ? state.auth.messages[0][
                      Object.keys(state.auth.messages[0])[0]
                    ]["user1"]
                  : state.auth.messages[0][
                      Object.keys(state.auth.messages[0])[0]
                    ]["user2"],
              );
            }
            setLoading(false);
          }

          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid
                    container
                    spacing={1.5}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item md={1}>
                      <Checkbox
                        labelStyle={{ color: themeStyle.primaryColor }}
                        iconStyle={{ fill: "white" }}
                        inputStyle={{ color: themeStyle.primaryColor }}
                        style={{
                          marginBottom: "2px",
                          color: themeStyle.primaryColor,
                        }}
                        checked={filterClass}
                        onChange={(e) => {
                          setFilterClass(e.target.checked);
                        }}
                        value={1}
                        color={"primary"}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <Select
                        value={classs}
                        onChange={(e) => handleClassChange(e)}
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        fullWidth
                        variant={"outlined"}
                      >
                        {getClassList()}
                      </Select>
                    </Grid>
                    <Grid item md={3}>
                      <Select
                        value={division}
                        onChange={(e) => handleDivisionChange(e)}
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        fullWidth
                        variant={"outlined"}
                      >
                        {getDivisionList()}
                      </Select>
                    </Grid>
                    <Grid item md={5}>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Search User / Email"
                        variant="outlined"
                        value={searchText}
                        size="small"
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                }
              />
              <Menu
                anchorEl={anchorEl}
                id={"menu"}
                keepMounted
                open={openMenu}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem
                  onClick={() => {
                    setOpen2(true);
                    setAnchorEl(null);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div
                    style={{
                      borderRadius: "15px",
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                    }}
                  >
                    {fileData()}
                  </div>
                </Fade>
              </Modal>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open2}
                onClose={() => setOpen2(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open2}>
                  <div
                    style={{
                      borderRadius: "15px",
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <h3>Delete this message?</h3>
                      <span>
                        This action cannot be reversed. It will be deleted
                        forever.
                      </span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => deleteMessage()}
                          style={{
                            height: "30px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                        >
                          Yes
                        </Button>
                        <Button
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          onClick={() => setOpen2(false)}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>
              <div
                style={{
                  borderRadius: "15px",
                  margin: "64px 0px 0px 70px",
                  backgroundColor: "white",
                  overflow: "hidden",
                  height: window.innerHeight - 70 + "px",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    float: "left",
                    overflowX: "scroll",
                    height: "100vh",
                  }}
                >
                  <ScrollLazyList
                    items={currentContacts ?? state.auth.messages}
                    full_name={state.auth.user.full_name}
                    user_id={state.auth.user.user_id}
                    selectedContact={selectedContact}
                    handleContactClick={handleContactClick}
                  />
                </div>

                <div
                  style={{
                    height: "100vh",
                    width: "75%",
                    float: "left",
                    overflow: "scroll",
                    borderLeft: "1px solid #ddd",
                  }}
                >
                  <div
                    style={{
                      marginTop: "80px",
                      minHeight: window.innerHeight - 70 - 70 + "px",
                    }}
                  >
                    {currentContacts != null
                      ? currentContacts.length == 0
                        ? ""
                        : getMessages()
                      : ""}
                    <div style={{ height: "100px" }}></div>
                  </div>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      borderRadius: "15px",
                      width: "100.5%",
                      backgroundColor: "white",
                      zIndex: 99,
                      bottom: 0,
                      position: "sticky",
                      borderTop: "1px solid #ddd",
                    }}
                  >
                    <Grid item xs={1}>
                      <label htmlFor="contained-button-file">
                        <input
                          style={{ display: "none" }}
                          id="contained-button-file"
                          type="file"
                          onChange={(e) => onFileChange(e)}
                        />

                        <Button
                          style={{
                            height: "40px",
                            boxShadow: "none",
                            left: 3,
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          component="span"
                        >
                          <AttachFileIcon style={{ marginTop: "5px" }} />
                        </Button>
                      </label>
                    </Grid>
                    <Grid item xs={10}>
                      <InputBase
                        value={textMessage}
                        onChange={(e) => handleTextChange(e)}
                        placeholder="Type Something"
                        style={{
                          zIndex: 99,
                          width: "100%",
                          bottom: -3,
                          fontSize: 19,
                        }}
                        inputProps={{ "aria-label": "message" }}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Button
                        onClick={() => sendMessage()}
                        style={{
                          height: "40px",
                          boxShadow: "none",
                          position: "absolute",
                          right: 8,
                          backgroundColor: themeStyle.primaryColor,
                        }}
                        aria-label="send"
                        variant="contained"
                      >
                        {isSending ? (
                          <CircularProgress
                            size={25}
                            style={{ color: "white" }}
                          />
                        ) : (
                          <SendIcon />
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Fragment>
          );
        } else {
          return (
            <div
              style={{
                borderRadius: "15px",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                marginTop: "46vh",
              }}
            >
              <CircularProgress />
            </div>
          );
        }
      } else {
        return <Navigate to="/expired" />;
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Messenger;
